module.exports = __webpack_public_path__ + "img/mrt_vision.64870c00.jpg";